import Spinner from '@atlaskit/spinner';
import moment from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from "react-redux";

import { accountService2, meetService } from '../../../../../service';
import { goToRoomWithToken } from '../../../../../utils';
import { Icon, IconCloseWhite, IconGroup } from '../../../base/icons';
import Card from '../atoms/Card';

import { UserData } from './UserList';

interface RecentCallProps {
    onChange: () => void,
    onClose: () => void
}


export const RecentCall: FC<RecentCallProps> = ({ onChange, onClose }) => {
    const [ isLoading, setIsLoading ] = useState(false);
    const [ recent, setRecent ] = useState([]);
    const avatarUser = 'https://dev.pantherconnect.me/images/gen-avatar.jpg';
    const { user } = useSelector((state) => state["features/settings"]);

    const fetchRecentCallData = async keywords => {
        setIsLoading(true);
        try {
            const response = await accountService2.getDataRecentCall(keywords);

            setRecent(response);
        } catch (e) {
            console.log(e);
        } finally {
            setIsLoading(false);
        }
    };
    const sortTime = (t1, t2, key) => {
        if (t1[key] > t2[key]) {
            return -1;
        }
        if (t1[key] < t2[key]) {
            return 1;
        }

        return 0;
    };

    useEffect(() => {
        fetchRecentCallData('');

        return () => {
            setRecent([]);
        };
    }, [ ]);

    const renderLabel = item => {
        const isToday = moment(item.createdDate).isSame(moment(), 'days');

        if (isToday) {
            return <div className = 'o-recent-call-in-dial-pad--label'>Today</div>;
        }

        const isYesterday = moment(item.createdDate).isSame(moment().subtract(1, 'days'), 'days');

        if (isYesterday) {
            return <div className = 'o-recent-call-in-dial-pad--label'>Yesterday</div>;
        }

        return <div className = 'o-recent-call-in-dial-pad--label'>{item.createdDate.locale('en').format('DD MMMM, YYYY')}</div>;
    };
    const onCallRecentList = async (item) => {
        const meeting = await meetService.createMeeting(item.id, `${user.firstName} ${user.lastName}`, user.email, user.id);
    
        const meetingrest = await meetService.getMeetingData(meeting?.data?.id);

        goToRoomWithToken(meetingrest.authRoom, meetingrest.token);
    }
    const renderReceivers = item =>
            <>{item?.receivers.map(receiver => renderItem(receiver, item))}</>

        ;

    const renderItem = (receiver: UserData, item) => (
        <>
            <div
                className = 'o-recent-call-in-dial-pad-item-container'
                key = { receiver.id }>
                {receiver.avatar
                    ? <img
                        className = 'o-user-list-item-img'
                        height = '48'
                        src = { receiver.avatar }
                        width = '48' />
                    : <img
                        className = 'o-user-list-item-img'
                        height = '48'
                        src = { avatarUser }
                        width = '48' />}
                <span
                    className = 'o-recent-call-in-dial-pad-item-name'
                    onClick = { () => {
                        onCallRecentList(item)
                    } }>{receiver.name ?? receiver.phoneNumber}</span>
                <Icon
                    size = { 24 }
                    src = { IconGroup } />
            </div>
        </>


    );
    const convertData = data => data.sort((r1, r2) => sortTime(r1, r2, 'createdDate')).map((item, index) => {
        if (moment(item.createdDate).format('DD/MM/YYYY')
            !== moment(recent[index - 1]?.createdDate).format('DD/MM/YYYY') || index === 0) {
            return (<>
                {
                    renderLabel(item)
                }
                {
                    renderReceivers(item)
                }
            </>);
        }

        return renderItem(item);
    });

    return (
        <>
            <Card className = 'o-recent-call-in-dial-pad w-recent'>
                <div className = { 'o-recent-call-in-dial-pad-close' }>
                    <div className = { 'o-recent-call-in-dial-pad-title' }>Recent calls</div>
                    <p onClick = { onClose }>
                        <Icon
                            size = { 20 }
                            src = { IconCloseWhite } />
                    </p>

                </div>
                <div className = 'o-recent-call-in-dial-pad-item'>
                    {isLoading ? <div className = 'o-phone-book-list-spinner'>
                        <Spinner size = { 'large' } />
                    </div> : <>
                        <div>
                            {convertData(recent)}
                        </div>
                    </>}
                </div>
                <div className = { 'o-recent-call-in-dial-pad--btn-sched-wrap' }>
                    <button
                        className = 'o-recent-call-in-dial-pad-btn-sched'
                        onClick = { () => onChange() }>
                        Schedule a call
                    </button>
                </div>
            </Card>
        </>
    );
};
RecentCall.defaultProps = {
    onChange: () => { },
    onClose: () => { }
};
